<template>
  <div class="presell-list" ref="Container">
    <div class="flash-sale">
      <div class='header'>
				<img mode="widthFix" class="presellBg" src="@assets/images/presell_bg.jpg" />	
			</div>
      <div class="main_count">
				<div class="presellList-cate-container">
          <div class="presellList acea-row row-between-wrapper">
					<div class='timeList'>
							<div class='item' 
                @click="settimeList(item,index)"
                v-for="(item,index) in timeList" 
                :key="index" 
                :class="active == index ? 'on': ''">
								<div class='time'><span>{{item}}</span></div>
							</div>
              <div class="timeList-line-box">
                <div class="timeList-line">
                  <div class="line-ball" :style="{left:timeListAct + '%'}"></div>
                </div>
              </div>
					</div>
				</div>
        </div>
				<div class='list'>
          <div 
            v-for="(item,index) in presellList"
            :key="index"
            @click="goDetails(item)"
            class="item-container">
            <div class='item acea-row row-between-wrapper'>
							<div class='pictrue'>
								<img :src='item.image' />
							</div>
							<div class='text acea-row row-column-around'>
								<div class='name line1'>{{item.store_name}}</div>
								<div class='booking'>
									<span 
                    v-if="item.presell_type != 0 && active != 0"
                    class="count" 
                    style="color: #999;">已预定{{item.tattend_one}}件</span>
									<span v-else style="color: #999; font-size: 12px;">暂未开始</span>
								</div>
								<div
                  v-if="item.coupon"
                  class='coupon acea-row row-between-wrapper' 
                  style="margin-top: 7px;">
									<div class='hide line1 acea-row'>									
										<div class='activity'>满{{item.coupon.use_min_price}}减{{item.coupon.coupon_price}}</div>
									</div>
								</div>
								<div class="progress">
									<div class='presell_price'>
										<span class="presell_text">¥ 预售价</span>
										<span class="price"><span>{{ item.price }}</span></span>
									</div>
									<div v-if="active != 0" class='order_btn'>{{ active === 1  ? '立即预定' : '已结束' }}</div>
									<div v-else class="unStartBtn">
										<span>开售时间</span>
										<div>{{ new Date(item.start_time.replace(/-/g,"/")).getMonth()+1 }}月
										{{ new Date(item.start_time.replace(/-/g,"/")).getDate() }}日 
										{{ new Date(item.start_time.replace(/-/g,"/")).getHours()<10?'0'+ 
										new Date(item.start_time.replace(/-/g,"/")).getHours():new Date(item.start_time.replace(/-/g,"/")).getHours() || '00'}}:
										{{ new Date(item.start_time.replace(/-/g,"/")).getMinutes()<10?"0" + new Date(item.start_time.replace(/-/g,"/")).getMinutes():
										new Date(item.start_time.replace(/-/g,"/")).getMinutes() || '00'}}</div>
									</div>
								</div>
							</div>
						</div>
          </div>
				</div>
        <Loading :loaded="loadend" :loading="pageloading"></Loading>
			</div>
      
    </div>
  </div>
</template>
<script>
import Loading from "@components/Loading";
import { getPresellList } from "@api/activity";
export default {
  name: "PresellList",
  components: {
    Loading
  },
  data() {
    return {
      topImage: "",
      presellList: [],
      timeList: ["未开始", "正在进行", "已结束"],
      active: 1,
      type: 0,
      scrollLeft: 0,
      interval: 0,
      status: 1,
      page: 1,
      limit: 3,
      loading: false,
      loadend: false,
      pageloading: false,
    };
  },
  created() {
    this.getPresellProductList();
  },
  mounted() {
    this.$scroll(this.$refs.Container,() => {
      !this.loading && this.getPresellProductList();
    })
  },
  computed:{
    timeListAct(){
      if(this.active == 0) return 16;
      if(this.active == 1) return 50;
      if(this.active == 2) return 85;
    }
  },
  methods: {
    getPresellProductList: function () {
      var that = this;
      var data = {
        page: that.page,
        limit: that.limit,
        type: that.active,
      };
      if (that.loadend) return;
      if (that.pageloading) return;
      this.pageloading = true;
      getPresellList(data)
        .then((res) => {
          console.log(res);
          var presellList = res.data.list;
          var loadend = presellList.length < that.limit;
          that.page++;
          (that.presellList = that.presellList.concat(presellList)),
            (that.page = that.page);
          that.pageloading = false;
          that.loadend = loadend;
        })
        .catch((err) => {
          that.pageloading = false;
        });
    },
    settimeList: function (item, index) {
      var that = this;
      if (that.active == index) return;
      that.active = index;
      that.type = that.active;
      that.loadend = false;
      that.page = 1;
      that.presellList = [];
      that.getPresellProductList();
    },
    goDetails(item){
      this.$router.push({
        path:`/activity/presell_details/${item.product_presell_id}`
      })
    }
  },
};
</script>
<style scoped>
.presell-list {
  background-color: #f50424  !important;
  min-height: 100vh;
}
.noCommodity {
  border-top: none;
}
.flash-sale .header {
  width: 100%;
  height: auto;
  position: relative;
}
.flash-sale .main_count {
  position: relative;
  top: -2.24rem;
}
.flash-sale .header .presellBg {
  width: 7.5rem;
}
.flash-sale .presellList-cate-container{
  padding: .28rem;
  margin: 0 .42rem;
  border-radius: 10px;
  background: #fff9db;
}
.flash-sale .presellList {
  /* padding: 0 0.2rem;
  bottom: 0; */
  /* margin: 0 0.3rem; */
  /* width: 6.9rem; */
  background: #fff;
  border-radius: 8px;
  /* line-height: 0.8rem; */
  /* height: 0.8rem; */
}

.flash-sale .presellList .priceTag {
  width: 0.75rem;
  height: 0.7rem;
}

.flash-sale .presellList .priceTag img {
  opacity: 1;
}

.flash-sale .presellList .priceTag img {
  width: 100%;
  height: 100%;
}

.flash-sale .timeList {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background: #fff9db;
  padding: .4rem .42rem .7rem .42rem;
  border: 1px solid #ff2221;
}

.flash-sale .timeList .item {
  font-size: 0.2rem;
  color: #666;
  text-align: center;
  box-sizing: border-box;
  width: 1.5rem;
  line-height: .45rem;
  background: #ffc645;
  border-radius: 5px;
  overflow: hidden;
}
.flash-sale .timeList .item.on{
  background: none;
  padding: .02rem;
  transform: scale(1.05);
  border: 1px solid #ffc645;
}
.flash-sale .timeList .item .time {
  font-size: 0.26rem;
  color: #fff;
  background: #ffc645;
  border-radius: 5px;
}
.flash-sale .timeList .item.on .time {
  color: #f90122;
  font-weight: 600;
}
.flash-sale .timeList .item.on .time span {
  position: relative;
}
.flash-sale .timeList .timeList-line-box{
  position: absolute;
  width: 90%;
  height: .04rem;
  background: #fedc86;
  left: 50%;
  top: 1.1rem;
  transform: translateX(-50%);
}
.flash-sale .timeList .timeList-line-box .timeList-line{
  position: relative;
  height: 100%;
}
.flash-sale .timeList .timeList-line-box .timeList-line .line-ball{
  position: absolute;
  width: .16rem;
  height: .16rem;
  background: #fdbf31;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
/* .flash-sale .timeList .item.on .time span::after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 0.04rem;
  background: #fd6523;
  position: absolute;
  left: 0;
  bottom: -0.04rem;
  border-radius: 1px;
} */
.activity {
  height: 0.56rem;
  padding: 0 11px;
  color: #e93323;
  font-size: 0.22rem;
  line-height: 0.5rem;
  position: relative;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIoAAAAiCAYAAACAyEHnAAABmUlEQVR4Xu3a0UrCYBTA8fNp0ERTtGURCBJ2E934DL1DD1kP4SN0VwhGF92UrhE5cxJtsYGw0ty5P/9dunOzPz/8vn3MzYa9U+GiQEkBBxSMaAoARVOJGQEKCFQFgKLKxBBQMKAqABRVJoaAggFVAaCoMjEEFAyoCgBFlYkhN704OnH7XoUUFPivQLqKE5fdvBGpXg069eSg3iAXBfIC8TL1E4lux8Hntch3DmV9pX3xgprfFq/263fSGSuQIfkKQjeR1frJN0A8nrVbzVajbiwNj1so8D5fROeT8KMYZQPKSGTvctjrUs5ogXiZjh6Cabbc7ISS3WSDaxSJiGQb1+797OVvga17EaAApRRKKlINhr1ju6l4cv/u+dWVLT1vg06T12TbWCrzRXS4azP71BevweuxbSXrM5Rtr8fZchNy4AaQYoF4mUoikT8OFk4k4QgfHqUF8iN8vsIv7cSACB9Xo0BXgH8UXSfzU0AxT0AXACi6TuangGKegC4AUHSdzE8BxTwBXQCg6DqZnwKKeQK6AEDRdTI/9QN+EIHHN2X4OwAAAABJRU5ErkJggg==");
  background-size: 100%;
  background-repeat: no-repeat;
}

.flash-sale .list {
  margin-top: 0.24rem;
}
.flash-sale .list .item-container{
  width: 6.66rem;
  padding: .24rem;
  margin: 0 auto;
  background: #fff9db;
  border-radius: 10px;
  margin-bottom: .27rem;
}
.flash-sale .list .item {
  height: 2.78rem;
  position: relative;
  /* width: 6.9rem; */
  /* margin: 0 auto 0.2rem auto; */
  margin-bottom: 0;
  background-color: #fff9db;
  border-radius: 10px;
  padding: 0 0.25rem;
  border: 1px solid #ff2221;
}

.flash-sale .list .item .pictrue {
  width: 2.39rem;
  height: 2.39rem;
  border-radius: 5px;
}

.flash-sale .list .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.flash-sale .list .item .text {
  width: 2.97rem;
  font-size: 0.3rem;
  color: #333;
}

.flash-sale .list .item .text .name {
  width: 100%;
  color: #282828;
  font-weight: bold;
  font-size: 0.28rem;
}

.flash-sale .list .item .text .booking {
  font-size: 0.3rem;
  color: #e93323;
}

.flash-sale .list .item .text .booking .count {
  font-size: 0.24rem;
  color: #e93323;
}

.flash-sale .list .item .text .limit {
  font-size: 0.22rem;
  color: #999;
  margin-bottom: 0.05rem;
}

.flash-sale .list .item .text .limit .limitPrice {
  margin-left: 1rem;
}
.flash-sale .list .item .text .progress {
  width: auto;
  height: 0.76rem;
  background-image: url("data:image/png;base64,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");
  background-color: transparent;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  margin-top: .36rem;
}
.flash-sale .list .item .text .progress .presell_price {
  float: left;
  width: 45%;
  text-align: center;
  line-height: 15px;
  padding: 0.08rem 0;
}
.flash-sale .list .item .text .progress .presell_price .presell_text {
  display: block;
  color: #e93323;
  font-size: 0.2rem;
  line-height: .26rem;
}
.flash-sale .list .item .text .progress .presell_price .price {
  font-size: 0.26rem;
  color: #e93323;
}
.flash-sale .list .item .text .progress .presell_price .price span {
  font-weight: bold;
}
.order_btn {
  float: left;
  width: 50%;
  text-align: center;
  color: #ffffff;
  font-size: 0.26rem;
  line-height: 0.76rem;
}
.unStartBtn {
  float: left;
  width: 55%;
  text-align: center;
  color: #ffffff;
  font-size: 0.2rem;
  padding: 0.08rem 0;
}
.unStartBtn text {
  font-size: 0.22rem;
}
</style>